export default {
	a_z: "A-Z",
	an_error_has_occurred_when_trying_to_redeem_the_item: "Un error ha ocurrido al intentar canjear el ítem",
	confirm_redeem: "Confirmar el canje",
	confirm_redeeming_the_item: "Confirma \"canjear el ítem\"",
	departments: "Departamentos",
	error_redeeming_item: "Error al canjear el ítem",
	for: "por",
	insuficient_points_for_redeem: "Puntos insuficientes para el canje",
	item_redeemed: "Ítem canjeado",
	no_rewards_found: "Ningún ítem encontrado",
	not_enough_items_in_stock: "Fuera de estoque",
	not_enough_points_to_redeem_item: "Puntos insuficientes para canjear el ítem",
	our_team_will_be_in_touch_for_the_next_steps: "La aprobación está pendiente de auditoría. Por favor, aguarda la confirmación.",
	popular: "Popular",
	price_bigger_to_smaller: "Ordenar por precio (del mayor al menor)",
	price_smaller_to_bigger: "Ordenar por precio (del menor al mayor)",
	redeem_now: "Canjear ahora",
	result_plural: "resultados",
	result: "resultado",
	search_for_rewards_here_to_redeem_with_your_points: "Bienvenido(a) a la tienda del programa Intel Te Premia. ¡Escoge el premio que más deseas!",
	search_partners_or_offerings: "Buscar productos, marcas y más",
	you_have_reached_the_max_number_of_redemptions_for_this_category: "Ya has realizado el máximo de canjes permitidos para esta categoría.",
	you_redeemed_successfully_the_item: "¡Canje identificado: "
}